import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  getRightContent,
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";
import { toggleSectionContentDisplay } from "../store/auxiliary/ui/sections";
import useAnimationAppear from "./hooks/useAnimationAppear";
import PlusButton from "./PlusButton";
import ResponsiveImage from "./ResponsiveImage";
import content from "../assets/content/content.json";
import PlusButton2 from "./PlusButton2";

function MainSectionImage({
  image,
  applyAnimationStartClassName,
  onApplyAnimationStart,
  applyAnimationReverseClassName,
  applyAnimationVanishClassName,
  onApplyAnimationReverse,
  displayContentEnabled,
  homeSection,
  applyAnimationMenuAppearClassName,
}) {
  const applyAnimationAppear = useAnimationAppear();
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <div
      className={`main-section-image__container${setAdditionalClasses(
        [
          "animate-image",
          "animate-image-reverse",
          "animate-image-vanish",
          "animate-image-appear",
          "pos-absolute",
        ],
        [
          applyAnimationStartClassName,
          applyAnimationReverseClassName,
          applyAnimationVanishClassName,
          !displayContentEnabled && applyAnimationAppear,
          displayContentEnabled,
        ]
      )}`}
      // style={{ backgroundImage: `url(${image[0]})` }}
    >
      <ResponsiveImage images={image} applyOverlay={false} />
      {/* <picture>
        <source
          media="(max-width: 500px)"
          srcSet={`${image[0]} 1x, ${image[1]} 2x`}
        />
        <source
          media="(min-width: 501px)"
          srcSet={`${image[2]} 450w, ${image[3]} 900w, ${image[4]} 1200w`}
        />
        <img src={`${image[5]}`} alt="" className="main-section-image" />
      </picture> */}
      {/* <img
        src={image[0]}
        alt=""
        className="main-section-image"
        srcSet={`${image[1]} 450w, ${image[2]} 900w, ${image[3]} 1200w`}
        style={{ objectFit: "cover", height: "100%" }}
      /> */}
      {/* <img
        src={image}
        alt=""
        // className={`main-section-image${setAdditionalClasses(
        //   ["animate-image"],
        //   [buttonClicked]
        // )}`}
        className={`main-section-image`}
      /> */}
      {!homeSection && (
        <div
          className={`main-section-image__expander${setAdditionalClasses(
            ["fade-out"],
            [applyAnimationStartClassName]
          )}`}
        >
          {!displayContentEnabled &&
            !applyAnimationVanishClassName &&
            !applyAnimationMenuAppearClassName && (
              <div
                style={getVisibleSensorAnimation(
                  !applyAnimationMenuAppearClassName,
                  "appear 1s backwards"
                )}
              >
                {/* <PlusButton
                  caption={getRightContent(
                    generalSettings.rtlLanguage,
                    content.generalTerms.readMore
                  )}
                  onButtonClick={onApplyAnimationStart}
                /> */}

                <PlusButton2
                  caption={getRightContent(
                    generalSettings.rtlLanguage,
                    content.generalTerms.readMore
                  )}
                  onButtonClick={onApplyAnimationStart}
                />
              </div>
            )}
        </div>
      )}
    </div>
  );
}

export default MainSectionImage;
